import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=d5ea5a40&"
import script from "./CustomButton.vue?vue&type=script&lang=ts&"
export * from "./CustomButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports